<template>
      <div class="lezhi-project3">
        <headerBlack-view></headerBlack-view>
        <div class="wrapper ">
            <div class="introduce_wrap flex-layout main">
                <div class="introduce_left">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">项目介绍</h2>
                            <img src="@/assets/yunqiao/introduce.png" />
                        </div>
                    </div>
                    <div class="introduce_name">中小学计算思维培养</div>
                    <div class="introduce_detail">
                      为银川师生提供学科项目式学习课程，一期包括语文、数学、外语、科学实践、计算思维等课程，以提升学生6大核心素养为核心，
                      通过双优云桥平台对学习成果进行沉淀、输出展示优秀学习成果。
                    </div>
                </div>
                <div class="introduce_right flex-layout ">
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/computer/01.png" />
                        <h3>6大核心素养</h3>
                        <span>Six Core Qualities</span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/computer/02.png" />
                        <h3>平台为载体</h3>
                        <span>Platform As Carrier</span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/computer/03.png" />
                        <h3>课测辅拓四大方式</h3>
                        <span>The Four Ways</span>
                    </div>
                </div>
            </div>    
            <div class="features-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">产品特点</h2>
                            <img src="@/assets/yunqiao/feature.png" />
                        </div>
                    </div>
                    <div class="features-items flex-layout">
                        <div class="item">
                           <h3>学生素养培育</h3>
                           <div class="">
                               <img src="@/assets/yunqiao/computer/icon01.png" alt="">
                           </div>
                           <p>以学生发展的6大核心要素匹<br>配对应的学习课程</p>
                        </div>
                        <div class="item">
                           <h3>师生共同进步</h3>
                           <div>
                               <img src="@/assets/yunqiao/computer/icon02.png" alt="">
                           </div>
                           <p> 为指导者、学习者提供项目式<br> 系列课程，支持合作式提升 </p>
                        </div>
                       <div class="item">
                           <h3> 全领域协同发展</h3>
                           <div>
                               <img src="@/assets/yunqiao/computer/icon03.png" alt="">
                           </div>
                           <p>项目涵盖了语文、数学、外语、<br> 科学实践、计算思维等课程 </p>
                        </div>
                        <div class="item">
                           <h3>多情景实际验证</h3>
                           <div>
                               <img src="@/assets/yunqiao/computer/icon04.png" alt="">
                           </div>
                           <p>理论+实践模式场景活动，使指导<br> 者和学习者能在学中做、做中学 </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="architecture-form">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu_white.png" />
                        <div class="">
                            <h2 class="f28" style="color:white">架构形式</h2>
                            <img src="@/assets/yunqiao/architecture.png" />
                        </div>
                    </div>
                    <div class="container flex-layout">
                        <div class="item">
                            <div>
                                <img src="@/assets/yunqiao/computer/icon05.png" alt="">
                            </div>
                            <h3>核心</h3>
                            <p>提升学生6大素养为核心，借助多<br> 领域课程做到全面发展。</p>
                        </div>
                        <div class="item">
                            <div>
                                <img src="@/assets/yunqiao/computer/icon06.png" alt="">
                            </div>
                            <h3>项目式课程</h3>
                            <p>为银川师生提供对应的项目式系列<br> 课程，课程涵盖广泛。</p>
                        </div>
                         <div class="item">
                            <div>
                                <img src="@/assets/yunqiao/computer/icon07.png" alt="">
                            </div>
                            <h3>输出成果</h3>
                            <p>依托平台，记录指导者、学习者学习<br> 过程和学习结果，并进行成果展示。</p>
                        </div>
                         <div class="item">
                            <div>
                                <img src="@/assets/yunqiao/computer/icon08.png" alt="">
                            </div>
                            <h3>课 辅 测 拓</h3>
                            <p>以课、测、辅、拓为内容，刷新课程观<br>念、提升知识学习和教材学习的效能为目标</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="win-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">合作共赢</h2>
                            <img src="@/assets/yunqiao/win2.png" />
                        </div>
                    </div>
                    <div class="container flex-align-between">
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/computer/04.png" />
                            <span>普惠银川师生</span>
                        </div>
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/computer/05.png" />
                            <span>多领域学科精品资源</span>
                        </div>
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/computer/06.png" />
                            <span>丰富的情景活动</span>
                        </div>
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/computer/07.png" />
                            <span>6大核心全面提高</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
    @import "./less/lezhi_common.less";
    @import "./less/lezhi_project3.less";
</style>